import Link from 'next/link';
import React from 'react';
import { MyImage } from '@/components/elements/MyImage';
import { Button } from '@/components/UI/Button';
import { useTranslationWithLocale } from '@/hooks';
import { windowIsReady } from '@/helpers/windowIsReady';
import { type DropdownItem } from '@/types';
import ArrowIcon from '@/public/icons/arrow-thin.svg';
import styles from './Item.module.scss';

interface Props {
	item: DropdownItem;
	toggleMenu?: () => void;
}
export const Item: React.FC<Props> = ({ item, toggleMenu }) => {
	const { t } = useTranslationWithLocale('landing-header');
	return (
		<Link
			href={`${item.href}?${new URLSearchParams(
				windowIsReady ? window.location.search : '',
			)}`}
			className={styles['item']}
			onClick={toggleMenu}
		>
			<MyImage
				imageProps={{
					src: item.image,
					alt: item.text,
				}}
				settings={{
					classes: {
						picture: styles['item__picture'],
						image: styles['item__image'],
					},
				}}
			/>
			<div className={styles['item__side']}>
				<p className={styles['item__text']}>{t(item.text)}</p>
				<Button
					as='div'
					Icon={ArrowIcon}
					classes={{
						button: styles['item__button'],
						icon: styles['item__icon'],
					}}
				/>
			</div>
		</Link>
	);
};
